module.exports = __webpack_public_path__ + "static/01-f407a3364952c9e4aacc87db19637b67.jpg";